import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CloseOutlined } from '@ant-design/icons';
import { Button, Form } from 'antd';
import TypeOfLeaveForm from '@/components/request/TypeOfLeaveForm';
import EmployeeNewRequestForm from '../../_components/form/EmployeeNewRequestForm';

/** The new-request flow, across the middle and right of the profile. */
export default function EmployeeRequestSection({
  employeeId,
  employee,
  formData,
  selectedTypeOfLeave,
  onClose,
}) {
  const { t } = useTranslation(['translations']);
  const [requestForm] = Form.useForm();
  const company = employee?.company;

  const companySettings = useMemo(() => {
    if (!company) return null;
    return {
      isSickLeaveRequest:
        company.applicationSettings?.isSickLeaveRequest || false,
      workTypes: company.calculationSettings?.workTypes || [],
      market: company.market || 'RS',
    };
  }, [company]);

  return (
    <section className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden rounded-[14px] bg-white">
      <div className="flex flex-wrap items-end justify-between gap-3 border-b border-zinc-200 px-4 py-3">
        <TypeOfLeaveForm
          form={requestForm}
          hasUploadedFiles
          companyId={company?._id}
          companySettings={companySettings}
          metadata={{ inputClassName: '', selectClassName: '' }}
        />
        <Button
          icon={<CloseOutlined />}
          className="btn-default btn-default--hover !rounded-[50px]"
          onClick={onClose}
        >
          {t('employeeProfile.close', { ns: 'translations' })}
        </Button>
      </div>
      <div className="min-h-0 flex-1 overflow-auto">
        <EmployeeNewRequestForm
          formData={formData}
          isEdited
          employeeId={employeeId}
          selectedTypeOfLeave={selectedTypeOfLeave}
          handleRefetch={() => {}}
        />
      </div>
    </section>
  );
}
